import React, { useState, useEffect } from 'react';
import { showToast } from './Toast';

function Builder() {
  const [selectedBase, setSelectedBase] = useState('pure_orig');
  const [selectedFruits, setSelectedFruits] = useState([]);
  const [selectedCrunch, setSelectedCrunch] = useState([]);
  const [selectedSauce, setSelectedSauce] = useState('honey');
  const [orderNotes, setOrderNotes] = useState('');

  const fruitLimit = 4;

  const basePrices = {
    pure_orig: { price: 49, name: 'Pure Scoop รสดั้งเดิม 70G' },
    pure_fruit: { price: 59, name: 'Pure Scoop รสผลไม้ 70G' },
    bowl_orig_s: { price: 69, name: 'Yogurt Bowl รสดั้งเดิม (S)' },
    bowl_orig_m: { price: 139, name: 'Yogurt Bowl รสดั้งเดิม (M)' },
    bowl_orig_l: { price: 169, name: 'Yogurt Bowl รสดั้งเดิม (L)' },
    bowl_fruit_s: { price: 79, name: 'Yogurt Bowl รสผลไม้ (S)' },
    bowl_fruit_m: { price: 159, name: 'Yogurt Bowl รสผลไม้ (M)' },
    bowl_fruit_l: { price: 189, name: 'Yogurt Bowl รสผลไม้ (L)' }
  };

  const fruits = [
    { id: 'mango', emoji: '🥭', name: 'มะม่วงสุก', desc: 'สดใหม่ รสหวานฉ่ำ' },
    { id: 'grape', emoji: '🍇', name: 'องุ่นไร้เมล็ด', desc: 'กรอบ หวานกำลังดี' },
    { id: 'apple', emoji: '🍎', name: 'แอปเปิ้ลฟูจิ', desc: 'กรุบกรอบ มีประโยชน์' },
    { id: 'kiwi', emoji: '🥝', name: 'กีวี่สด', desc: 'เปรี้ยวหวานลงตัว' },
    { id: 'blueberry', emoji: '🫐', name: 'บลูเบอร์รี่', desc: 'ซูเปอร์ฟู้ด ยอดฮิต' }
  ];

  const crunchOptions = [
    { id: 'oat', emoji: '🌾', name: 'โอ๊ตเฟล็กซ์', desc: '+฿10 อุดมด้วยไฟเบอร์' },
    { id: 'granola', emoji: '🥣', name: 'กราโนล่าโฮมเมด', desc: '+฿10 หอมน้ำผึ้งกรอบนาน' }
  ];

  useEffect(() => {
    const handleQuickMenu = (event) => {
      const { menuCode, price } = event.detail;
      
      setSelectedFruits([]);
      setSelectedCrunch([]);
      
      if (menuCode === 'MX') {
        setSelectedFruits(['mango', 'grape', 'apple', 'kiwi']);
        setSelectedBase('bowl_orig_l');
        setSelectedSauce('honey');
      } else if (menuCode === 'Mango Bliss') {
        setSelectedFruits(['mango', 'blueberry']);
        setSelectedBase('bowl_orig_m');
        setSelectedSauce('honey');
      } else if (menuCode === 'Oatflake Apple') {
        setSelectedFruits(['apple', 'blueberry']);
        setSelectedCrunch(['oat', 'granola']);
        setSelectedBase('bowl_orig_m');
        setSelectedSauce('honey');
      }

      setTimeout(() => {
        document.getElementById('builder')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);

      showToast(`โหลดสูตรด่วน "${menuCode}" ลงในกล่องตกแต่งแล้ว!`, true);
    };

    window.addEventListener('selectQuickMenu', handleQuickMenu);
    return () => window.removeEventListener('selectQuickMenu', handleQuickMenu);
  }, []);

  const toggleFruit = (fruitId) => {
    setSelectedFruits(prev => 
      prev.includes(fruitId) 
        ? prev.filter(f => f !== fruitId)
        : [...prev, fruitId]
    );
  };

  const toggleCrunch = (crunchId) => {
    setSelectedCrunch(prev =>
      prev.includes(crunchId)
        ? prev.filter(c => c !== crunchId)
        : [...prev, crunchId]
    );
  };

  const calculateTotal = () => {
    let total = basePrices[selectedBase].price;
    
    const extraFruits = Math.max(0, selectedFruits.length - fruitLimit);
    total += extraFruits * 15;
    
    total += selectedCrunch.length * 10;
    
    return total;
  };

  const getFruitName = (fruitId) => {
    const fruit = fruits.find(f => f.id === fruitId);
    return fruit ? `${fruit.name} ${fruit.emoji}` : fruitId;
  };

  const getCrunchName = (crunchId) => {
    const crunch = crunchOptions.find(c => c.id === crunchId);
    return crunch ? `${crunch.name} ${crunch.emoji}` : crunchId;
  };

  const handleSubmitOrder = () => {
    const baseName = basePrices[selectedBase].name;
    const fruitsText = selectedFruits.length > 0 
      ? selectedFruits.map(f => getFruitName(f).split(' ')[0]).join(', ')
      : 'ไม่ใส่ผลไม้';
    const crunchText = selectedCrunch.length > 0
      ? selectedCrunch.map(c => getCrunchName(c).split(' ')[0]).join(', ')
      : 'ไม่ใส่ท็อปปิ้งกรอบ';
    const sauceText = selectedSauce === 'honey' ? 'ราดน้ำผึ้งป่า' : 'ไม่เติมหวาน';
    const notesText = orderNotes || 'ไม่มี';
    const totalPrice = calculateTotal();

    const orderText = `✨ ออเดอร์ลูกค้า DIY (Sunday Dairy) ✨\n\n` +
      `• ขนาด: ${baseName}\n` +
      `• ผลไม้: ${fruitsText}\n` +
      `• ท็อปปิ้งกรอบ: ${crunchText}\n` +
      `• ความหวาน: ${sauceText}\n` +
      `• หมายเหตุเพิ่มเติม: ${notesText}\n\n` +
      `💰 ยอดรวมประมาณการ: ฿${totalPrice}\n\n` +
      `--------------------------\n` +
      `(ก๊อปปี้ข้อความนี้ส่งแชทให้ร้านที่ LINE: NUTCHEEFUL ได้ทันทีนะคะ)`;

    navigator.clipboard.writeText(orderText).then(() => {
      showToast('คัดลอกรายละเอียดสูตรของคุณลง Clipboard เรียบร้อยแล้ว! นำไปส่งที่ LINE ได้ทันที');
    });
  };

  const renderBillItems = () => {
    const baseInfo = basePrices[selectedBase];
    const total = calculateTotal();

    return (
      <>
        <div className="flex justify-between">
          <span className="text-brand-200">🥛 {baseInfo.name}</span>
          <span className="font-semibold">฿{baseInfo.price}</span>
        </div>

        {selectedFruits.length > 0 && (
          <>
            <div className="mt-2 text-xs text-brand-300 font-medium">ผลไม้ที่เลือก:</div>
            {selectedFruits.map((fruit, idx) => {
              const isExtra = idx >= fruitLimit;
              return (
                <div key={fruit} className="flex justify-between pl-3 text-xs text-brand-100">
                  <span>- {getFruitName(fruit)}</span>
                  <span>{isExtra ? '+฿15' : 'ฟรี'}</span>
                </div>
              );
            })}
          </>
        )}

        {selectedCrunch.length > 0 && (
          <>
            <div className="mt-2 text-xs text-brand-300 font-medium">ท็อปปิ้งความกรอบ:</div>
            {selectedCrunch.map(crunch => (
              <div key={crunch} className="flex justify-between pl-3 text-xs text-brand-100">
                <span>- {getCrunchName(crunch)}</span>
                <span>+฿10</span>
              </div>
            ))}
          </>
        )}

        {selectedSauce === 'honey' && (
          <div className="flex justify-between mt-2 border-t border-brand-800/40 pt-2 text-xs text-brand-100">
            <span>🍯 เติมน้ำผึ้งป่าธรรมชาติ</span>
            <span className="text-brand-300">ฟรี</span>
          </div>
        )}
      </>
    );
  };

  return (
    <section id="builder" className="py-20 lg:py-24 bg-white border-b border-brand-200/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14 space-y-3">
          <div className="inline-flex items-center gap-2 text-brand-600">
            <span className="w-6 h-[1px] bg-brand-400"></span>
            <span className="text-[11px] uppercase tracking-[0.25em] font-bold">
              Artisan Bowl Builder
            </span>
            <span className="w-6 h-[1px] bg-brand-400"></span>
          </div>

          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal text-brand-900 tracking-tight">
            Design Your Own Bowl
          </h2>

          <p className="text-xs sm:text-sm text-brand-600/80 font-light">
            เลือกสรรเบสกรีกโยเกิร์ต ผลไม้สด และท็อปปิ้งพรีเมียมตามใจคุณ พร้อมส่งสั่งซื้อผ่าน LINE
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-7 bg-[#FAFCFE] p-6 sm:p-8 rounded-3xl border border-brand-200/80 shadow-xs space-y-8">
            
            <div>
              <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600 block mb-3">
                Step 1: เลือกขนาด & เบสโยเกิร์ต
              </span>

              <span className="text-xs font-semibold uppercase tracking-wider text-brand-800 block mt-4 mb-2">
                Pure Scoop 70G
              </span>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                {['pure_orig', 'pure_fruit'].map(base => (
                  <label key={base} className="relative flex items-center p-3.5 bg-white border border-brand-200/80 rounded-2xl cursor-pointer hover:border-brand-500 transition-all shadow-2xs">
                    <input
                      type="radio"
                      name="base"
                      value={base}
                      checked={selectedBase === base}
                      onChange={(e) => setSelectedBase(e.target.value)}
                      className="sr-only peer"
                    />
                    <div className="flex flex-col flex-1">
                      <span className="font-semibold text-brand-900 text-xs sm:text-sm">
                        {base === 'pure_orig' ? 'รสดั้งเดิม (Pure Classic)' : 'รสผลไม้ (Berry Fruit)'}
                      </span>
                    </div>
                    <div className="text-right mr-3">
                      <span className="font-bold text-brand-700 block text-xs sm:text-sm">฿{basePrices[base].price}</span>
                    </div>
                    <span className="w-4 h-4 rounded-full border-2 border-brand-300 peer-checked:bg-brand-600 peer-checked:border-brand-600 inline-block shrink-0 transition-colors"></span>
                  </label>
                ))}
              </div>

              <span className="text-xs font-semibold uppercase tracking-wider text-brand-800 block mt-4 mb-2">
                Yogurt Bowl รสดั้งเดิม <span className="text-[11px] font-normal text-brand-500">(ฟรีผลไม้ 4 ชนิด)</span>
              </span>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
                {['bowl_orig_s', 'bowl_orig_m', 'bowl_orig_l'].map(base => (
                  <label key={base} className="relative flex items-center p-3.5 bg-white border border-brand-200/80 rounded-2xl cursor-pointer hover:border-brand-500 transition-all shadow-2xs">
                    <input
                      type="radio"
                      name="base"
                      value={base}
                      checked={selectedBase === base}
                      onChange={(e) => setSelectedBase(e.target.value)}
                      className="sr-only peer"
                    />
                    <div className="flex flex-col flex-1">
                      <span className="font-semibold text-brand-900 text-xs sm:text-sm">
                        Size {base.includes('_s') ? 'S' : base.includes('_m') ? 'M' : 'L'}
                      </span>
                    </div>
                    <div className="text-right mr-3">
                      <span className="font-bold text-brand-700 block text-xs sm:text-sm">฿{basePrices[base].price}</span>
                    </div>
                    <span className="w-4 h-4 rounded-full border-2 border-brand-300 peer-checked:bg-brand-600 peer-checked:border-brand-600 inline-block shrink-0 transition-colors"></span>
                  </label>
                ))}
              </div>

              <span className="text-xs font-semibold uppercase tracking-wider text-brand-800 block mt-4 mb-2">
                Yogurt Bowl รสผลไม้ <span className="text-[11px] font-normal text-brand-500">(ฟรีผลไม้ 4 ชนิด)</span>
              </span>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {['bowl_fruit_s', 'bowl_fruit_m', 'bowl_fruit_l'].map(base => (
                  <label key={base} className="relative flex items-center p-3.5 bg-white border border-brand-200/80 rounded-2xl cursor-pointer hover:border-brand-500 transition-all shadow-2xs">
                    <input
                      type="radio"
                      name="base"
                      value={base}
                      checked={selectedBase === base}
                      onChange={(e) => setSelectedBase(e.target.value)}
                      className="sr-only peer"
                    />
                    <div className="flex flex-col flex-1">
                      <span className="font-semibold text-brand-900 text-xs sm:text-sm">
                        Size {base.includes('_s') ? 'S' : base.includes('_m') ? 'M' : 'L'}
                      </span>
                    </div>
                    <div className="text-right mr-3">
                      <span className="font-bold text-brand-700 block text-xs sm:text-sm">฿{basePrices[base].price}</span>
                    </div>
                    <span className="w-4 h-4 rounded-full border-2 border-brand-300 peer-checked:bg-brand-600 peer-checked:border-brand-600 inline-block shrink-0 transition-colors"></span>
                  </label>
                ))}
              </div>
            </div>

            <div>
              <div className="flex justify-between items-center mb-3">
                <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600">
                  Step 2: เลือกผลไม้สด (ฟรี 4 อย่าง เพิ่มอย่างละ ฿15)
                </span>
                <span className="text-[10px] bg-brand-600 text-white px-2.5 py-0.5 rounded-full font-bold uppercase tracking-wider">
                  ฟรี 4 ชนิด
                </span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {fruits.map(fruit => (
                  <button
                    key={fruit.id}
                    onClick={() => toggleFruit(fruit.id)}
                    className={`p-3 bg-white border rounded-2xl text-left hover:border-brand-500 transition-all flex items-center space-x-2.5 shadow-2xs ${
                      selectedFruits.includes(fruit.id) ? 'border-brand-600 bg-brand-100/60 ring-2 ring-brand-500/20' : 'border-brand-200/80'
                    }`}
                  >
                    <span className="text-xl">{fruit.emoji}</span>
                    <div className="flex-1">
                      <span className="text-xs font-semibold text-brand-900 block">{fruit.name}</span>
                      <span className="text-[10px] text-brand-500 font-light">{fruit.desc}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <div>
              <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600 block mb-3">
                Step 3: เพิ่มท็อปปิ้งความกรุบกรอบ (+฿10)
              </span>
              <div className="grid grid-cols-2 gap-3">
                {crunchOptions.map(crunch => (
                  <button
                    key={crunch.id}
                    onClick={() => toggleCrunch(crunch.id)}
                    className={`p-3 bg-white border rounded-2xl text-left hover:border-brand-500 transition-all flex items-center space-x-2.5 shadow-2xs ${
                      selectedCrunch.includes(crunch.id) ? 'border-brand-600 bg-brand-100/60 ring-2 ring-brand-500/20' : 'border-brand-200/80'
                    }`}
                  >
                    <span className="text-xl">{crunch.emoji}</span>
                    <div className="flex-1">
                      <span className="text-xs font-semibold text-brand-900 block">{crunch.name}</span>
                      <span className="text-[10px] text-brand-500 font-light">{crunch.desc}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <div>
              <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600 block mb-3">
                Step 4: เติมความหวาน (ฟรี 1 อย่าง)
              </span>
              <div className="grid grid-cols-2 gap-3">
                <label className="relative flex items-center justify-between p-3.5 bg-white border border-brand-200/80 rounded-2xl cursor-pointer hover:border-brand-500 transition-all shadow-2xs">
                  <input
                    type="radio"
                    name="sauce"
                    value="honey"
                    checked={selectedSauce === 'honey'}
                    onChange={(e) => setSelectedSauce(e.target.value)}
                    className="sr-only peer"
                  />
                  <div className="flex items-center space-x-2.5">
                    <span className="text-lg">🍯</span>
                    <span className="text-xs font-semibold text-brand-900">น้ำผึ้งป่าธรรมชาติ</span>
                  </div>
                  <span className="w-4 h-4 rounded-full border-2 border-brand-300 peer-checked:bg-brand-600 peer-checked:border-brand-600 transition-colors"></span>
                </label>

                <label className="relative flex items-center justify-between p-3.5 bg-white border border-brand-200/80 rounded-2xl cursor-pointer hover:border-brand-500 transition-all shadow-2xs">
                  <input
                    type="radio"
                    name="sauce"
                    value="none"
                    checked={selectedSauce === 'none'}
                    onChange={(e) => setSelectedSauce(e.target.value)}
                    className="sr-only peer"
                  />
                  <div className="flex items-center space-x-2.5">
                    <span className="text-lg">❌</span>
                    <span className="text-xs font-semibold text-brand-900">ไม่รับความหวาน</span>
                  </div>
                  <span className="w-4 h-4 rounded-full border-2 border-brand-300 peer-checked:bg-brand-600 peer-checked:border-brand-600 transition-colors"></span>
                </label>
              </div>
            </div>
          </div>

          {/* Right Summary Column: Deep Aegean Navy */}
          <div className="lg:col-span-5 bg-brand-800 text-white p-6 sm:p-8 rounded-3xl border border-brand-700/80 sticky top-24 shadow-xl flex flex-col justify-between space-y-8">
            <div>
              <div className="flex justify-between items-center pb-4 border-b border-brand-700/80">
                <h3 className="font-serif text-2xl font-normal tracking-wide">Your Bowl Recipe</h3>
                <span className="text-[10px] bg-brand-700 text-brand-200 px-3 py-1 rounded-full border border-brand-600 uppercase tracking-widest font-semibold">
                  Custom Recipe
                </span>
              </div>

              <div className="py-6 space-y-3 text-sm">
                {renderBillItems()}
              </div>

              <div className="pt-4 border-t border-brand-700/80 space-y-2">
                <label className="text-xs text-brand-300 block font-light">หมายเหตุถึงร้านค้า (ถ้ามี):</label>
                <input
                  type="text"
                  value={orderNotes}
                  onChange={(e) => setOrderNotes(e.target.value)}
                  placeholder="เช่น ขอแอปเปิ้ลเยอะๆ, แยกน้ำผึ้ง..."
                  className="w-full bg-brand-900/80 border border-brand-700 rounded-xl px-3.5 py-2.5 text-xs focus:outline-none focus:border-brand-400 text-white placeholder-brand-400"
                />
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex justify-between items-end">
                <span className="text-xs text-brand-300 uppercase tracking-wider">Estimated Total</span>
                <span className="font-serif text-3xl font-bold text-white">฿{calculateTotal()}</span>
              </div>
              <button
                onClick={handleSubmitOrder}
                className="w-full py-4 bg-brand-100 hover:bg-white text-brand-900 font-bold rounded-2xl transition-all shadow-md flex items-center justify-center space-x-2 text-xs uppercase tracking-widest"
              >
                <i className="fab fa-line text-lg text-emerald-600"></i>
                <span>สั่งซื้อผ่าน LINE OA</span>
              </button>
              <p className="text-[10px] text-brand-300/80 text-center leading-normal font-light">
                *ระบบจะคัดลอกรายการสรุป ให้คุณนำไปวางในแชท LINE: NUTCHEEFUL ได้ทันที
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Builder;
